"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGiveawayTimer = void 0;
const useGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection");
const react_1 = require("react");
const useCreatorDataApi_1 = require("root/src/client/logic/api/hooks/useCreatorDataApi");
const useCountdown_1 = require("root/src/client/v2/common/hooks/useCountdown");
const rewards_api_contract_1 = require("@daredrop-com/rewards-api-contract");
const useGiveawayApi_1 = require("root/src/client/web/giveaway/hooks/useGiveawayApi");
const useGiveawayTimer = () => {
    const creatorDataApi = (0, useCreatorDataApi_1.useCreatorDataApi)();
    const giveawayApi = (0, useGiveawayApi_1.useGiveawayApi)();
    const { classes, giveaway } = (0, useGiveawaySection_1.useGiveawaySection)();
    const { timeLeft, interval } = (0, useCountdown_1.useCountdown)((giveaway === null || giveaway === void 0 ? void 0 : giveaway.endDate) || new Date());
    (0, react_1.useEffect)(() => {
        return () => {
            void creatorDataApi.fetchGiveaways();
            void giveawayApi.fetchVouchers(rewards_api_contract_1.VoucherStatus.Available);
            interval.clear();
        };
    }, []);
    const isPickingWinner = (giveaway === null || giveaway === void 0 ? void 0 : giveaway.status) === rewards_api_contract_1.GiveawayStatus.Active && timeLeft <= 0;
    return {
        classes,
        formattedISOTimeLeft: (0, useCountdown_1.formatISOTimeLeft)(timeLeft),
        isPickingWinner,
    };
};
exports.useGiveawayTimer = useGiveawayTimer;
